import { getAbbrMonthsNames } from "../../../../js/utils/functions";
import { config } from "../config";

const getISODate = (date) => date.toISOString().split("T")[0];

const getLocaleString = (date) => date.toLocaleString();

const roundUpSeconds = (date) => {
  const newDate = new Date(date.getTime());
  newDate.setMinutes(date.getMinutes() + 1);
  newDate.setSeconds(0);
  newDate.setMilliseconds(0);
  return newDate;
};

export const addDays = (date, days) => {
  const newDate = new Date();
  newDate.setDate(date.getDate() + days);
  return roundUpSeconds(new Date(newDate));
};

export const subtractHours = (date, hours) => {
  const newDate = new Date();
  newDate.setTime(date.getTime() - hours * 60 * 60 * 1000);
  return roundUpSeconds(new Date(newDate));
};

export const diffBetweenDates = (start, end) => {
  if (!(start instanceof Date) || !(end instanceof Date)) {
    return 0;
  }

  return end - start;
};

export const millisToHours = (time) => {
  if (!time) {
    return 0;
  }

  return time / 1000 / 60 / 60;
};

export const getMinScheduleDate = () =>
  getISODate(addDays(new Date(), config.MIN_DAYS_SCHEDULE_LIVE_SESSION));

export const getLocaleMinScheduleDate = () =>
  getLocaleString(addDays(new Date(), config.MIN_DAYS_SCHEDULE_LIVE_SESSION));

export const getMaxScheduleDate = () =>
  getISODate(addDays(new Date(), config.MAX_DAYS_SCHEDULE_LIVE_SESSION));

export const getLocaleMaxScheduleDate = () =>
  getLocaleString(addDays(new Date(), config.MAX_DAYS_SCHEDULE_LIVE_SESSION));

export const isInvalidMinScheduleDate = (date) => {
  if (!date) {
    return true;
  }

  const now = new Date();
  const minDate = addDays(now, config.MIN_DAYS_SCHEDULE_LIVE_SESSION);
  return date.getTime() < minDate.getTime();
};

export const isInvalidMaxScheduleDate = (date) => {
  if (!date) {
    return true;
  }

  const now = new Date();
  const maxDate = addDays(now, config.MAX_DAYS_SCHEDULE_LIVE_SESSION);
  return date.getTime() > maxDate.getTime();
};

export const updateScheduleDate = (date, scheduleDate) => {
  const validDate = date?.length;
  if (validDate) {
    const scheduleHours = scheduleDate ? scheduleDate.getHours() : null;
    const scheduleMinutes = scheduleDate ? scheduleDate.getMinutes() : null;

    const newScheduleDate = new Date(date);
    if (scheduleHours) {
      newScheduleDate.setHours(scheduleHours);
    }

    if (scheduleMinutes) {
      newScheduleDate.setMinutes(scheduleMinutes);
    }
    return newScheduleDate;
  }

  return null;
};

export const updateScheduleTime = (time, scheduleDate) => {
  const validTime = time?.length && time.split(":").length === 2;
  if (validTime) {
    const newScheduleDate = scheduleDate || new Date();
    const timeSplit = time.split(":");
    newScheduleDate.setHours(timeSplit[0]);
    newScheduleDate.setMinutes(timeSplit[1]);
    return newScheduleDate;
  }

  return null;
};

const padNumber = (number) => (number < 10 ? `0${number}` : number);

export const getDateInputValueFromString = (value) => {
  if (value) {
    const date = new Date(value);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}-${padNumber(month)}-${padNumber(day)}`;
  }

  return null;
};

export const getTimeInputValueFromString = (value) => {
  if (value) {
    const date = new Date(value);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return `${padNumber(hours)}:${padNumber(minutes)}`;
  }

  return null;
};

let abbrMonthsNames = null;

const getAbbrMonthName = (monthNumber) => {
  if (!abbrMonthsNames) {
    abbrMonthsNames = getAbbrMonthsNames();
  }

  return abbrMonthsNames[monthNumber];
};

export const formatLiveSessionDate = (strDate) => {
  const date = new Date(strDate);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${getAbbrMonthName(month)} ${day}`;
};

export const formatLiveSessionDuration = (strStartDate, strFinishDate) => {
  if (!strStartDate || !strFinishDate) {
    return "-";
  }

  try {
    const startDate = new Date(strStartDate);
    const finishDate = new Date(strFinishDate);
    const diff = Math.floor((finishDate.getTime() - startDate.getTime()) / 1000);
    const hours = Math.floor(diff / 3600);
    const minutes = Math.floor((diff - hours * 3600) / 60);

    if (!hours && !minutes) {
      return "-";
    }

    const minutesLabel = I18n.t("datetime.distance_in_words.x_minutes_acronym.other", {
      count: minutes,
    });

    const hoursLabel = I18n.t("datetime.distance_in_words.x_hours_short.other", { count: hours });

    if (!hours) {
      return minutesLabel;
    }

    if (minutes === 0) {
      return hoursLabel;
    }

    return `${hoursLabel}, ${minutesLabel}`;
  } catch {
    return "-";
  }
};

export const formatLiveSessionScheduledAt = (strScheduledAt) => {
  const formattedDate = formatLiveSessionDate(strScheduledAt);
  const date = new Date(strScheduledAt);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  return `${formattedDate}, ${padNumber(hours)}:${padNumber(minutes)}`;
};
